import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function WhatsInside() {
  const revealRef = useScrollReveal();
  const items = ['6 capítulos de transformación progresiva', 'Técnica de la Doble Rendija Emocional', 'Protocolo de Acceso al Estado Cero', 'Meditación de Reescritura Cuántica — 4 fases', 'Módulo especial: Activación de la Glándula Pineal', 'Checklists de conciencia atómica por módulo', 'Glosario cuántico del Observador Consciente', 'Frecuencias Solfeggio 528Hz y 963Hz', 'Mapa visual completo del proceso', 'FAQ del proceso de transformación'];
  return <section className="bg-brand-cream py-[60px] md:py-[100px] px-[5%]" data-id="element-234">
      <div ref={revealRef} className="max-w-7xl mx-auto reveal" data-id="element-235">
        <div className="text-center mb-[56px]" data-id="element-236">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-237">
            CONTENIDO
          </div>
          <h2 className="font-display italic text-[clamp(36px,5vw,48px)] text-brand-ink leading-tight mb-4" data-id="element-238">
            Todo lo que contiene el Protocolo
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2" data-id="element-239">
          {items.map((item, i) => <div key={i} className="flex items-start gap-3 py-[14px] border-b border-brand-ink/10 transition-all duration-300 hover:translate-x-2" data-id="element-240">
              <div className="text-brand-gold text-[16px] shrink-0 mt-[2px]" data-id="element-241">
                ✦
              </div>
              <div className="font-body text-[15px] text-brand-ink/80" data-id="element-242">
                {item}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}